function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconShineFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.838 26.317a9.294 9.294 0 00-6.142-6.142L2.238 19.11c-.318-.098-.317-.549 0-.647l3.458-1.066a9.294 9.294 0 006.142-6.142l1.067-3.457c.097-.319.548-.318.646 0l1.066 3.457a9.294 9.294 0 006.142 6.142l3.458 1.067c.318.097.317.548 0 .646l-3.458 1.066a9.294 9.294 0 00-6.142 6.142l-1.067 3.458a.338.338 0 01-.646-.001l-1.066-3.457zm1.17-2.812l.22.396.218-.396a11.488 11.488 0 014.5-4.5l.397-.22-.396-.218a11.487 11.487 0 01-4.5-4.5l-.22-.397-.219.396a11.487 11.487 0 01-4.5 4.5l-.396.22.396.219a11.486 11.486 0 014.5 4.5zM24 6.576C23.6 7.12 23.12 7.6 22.576 8c.544.4 1.024.88 1.424 1.424.4-.544.88-1.024 1.424-1.424A6.668 6.668 0 0124 6.576zm3.976 2.275a4.724 4.724 0 00-3.125 3.125l-.557 1.807a.308.308 0 01-.588 0l-.557-1.807a4.729 4.729 0 00-3.125-3.125l-1.807-.557a.308.308 0 010-.588l1.807-.557a4.724 4.724 0 003.125-3.125l.557-1.807c.088-.29.499-.29.588 0l.557 1.807a4.726 4.726 0 003.125 3.125l1.807.557c.29.09.29.499 0 .588l-.2.062h-.001l-1.606.495z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 25h-3v-3h-2v3h-3v2h3v3h2v-3h3v-2z",
    fill: props.color
  }));
}

export default SvgIconShineFilled;